
// depends on cordova-plugin-file (resolveLocalFileSystemURL)
// android > 4.4, ios >10
import { imagePicker } from './ImagePicker.js';
class FileTransfer{
    constructor(){
    }
    
    async uploadFile(localFileUrl,server_url,params){
      
      console.log("upload file",server_url)
      //localFileUrl  is cdvFile://
      // test if localFileUrl is already base64 data...
      var arr = localFileUrl.split(',')
      var mime;
      
      try{
        // yes is is probabely, unless mimetype is part of the url...
        mime= arr[0].match(/:(.*?);/)[1];
      }catch(e){
        mime="";
      }
      
      var blob;
      

      switch(mime){
        case "image/jpeg":
          await imagePicker.resizeBase64ToBlob(localFileUrl,1920).then(result=>{
            blob=result;
          });
        break;
        case "image/png":
          await imagePicker.resizeBase64ToBlob(localFileUrl,1920).then(result=>{
            blob=result;
          });
            
        break;
        case "application/pdf":
          blob=imagePicker._base64DataToBlob(localFileUrl);
        break;
        case "audio/mpeg":
          blob=imagePicker._base64DataToBlob(localFileUrl);
        break;
        default:
          // no mimetype so must be url
          // get file blob from url
          await imagePicker.resizeUrlToBlob(localFileUrl,1920).then(result=>{
            blob=result;
          });
        break;
      }
      
      
      
      // return promise from http request
      return this.httpRequest(server_url,blob,params);


  }


    httpRequest(server_url,blob,params){
      
      return new Promise((resolve,reject)=>{

      var oReq = new XMLHttpRequest();
           
          oReq.open("POST", server_url ,true);
          oReq.onload = ()=>{
            if (oReq.status != 200) { // analyze HTTP status of the response
              reject(oReq.status+":"+oReq.statusText);
            } else { // ok!
              //console.dir(oReq)
              // it lookslike there is a bug in the php side where
              // sending images too quickly, sometimes the filenames get mixed up..
              // so we allow a timeout here
              setTimeout(()=>{
                resolve(oReq.response);
              },0);
              
              
            }
          };
          oReq.onerror = function() {
            reject("Request Failed...")
          };

          // connection close was implemented in the previous file transfer..
          // we might want to keep the connection open to gain some performance?
          // oReq.setRequestHeader("Connection", "close");
          
          var fd=new FormData();

          // propagate from data
          for(var key in params){
            fd.append(key,params[key]);
          }
          // pass the blob (might want to add base 64 string in front on serverside?)
          if(params.file_name){
            fd.append("file",blob,params.file_name);
          }else{
            if(!params.file_name){ alert("missing file_name in params")}
          }
         
          oReq.send(fd);

        });// promise
    }
  }

export let fileTransfer = new FileTransfer();







